import dataSourceConfig from './views/dataSourceConfig.html'

class externalSystemlistCtrl {
    constructor($scope, httpRequest, $state, sweetalert, logger, $uibModal) {
        $scope.dictData = {}
        const typecodeArr = ['event_type', 'encrypt_type','uims_interface_type', 'data_client_type', 'data_database_type','ivat_source_app_id']
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                clientName: '',
                status: '',
            },
        }
        $scope.reset = function reset() {
            $scope.queryParam.param = {
                clientName: '',
                status: '',
            }
        }
        $scope.querySystemList = function querySystemList() {
            $scope.queryParam = sessionStorage.externalSystemListParam ? JSON.parse(sessionStorage.externalSystemListParam) : $scope.queryParam
            httpRequest.post_listClientDetails($scope.queryParam).then((res) => {
                const result = res.data.value.list
                if ($scope.dictData.event_type) {
                    result.forEach((item) => {
                        if (item.eventTypes && item.eventTypes.length > 0) {
                            item.eventTypeStr = dictDataHandle(item.eventTypes)
                        }
                        if (item.status == 1) {
                            item.statusStr = '启用'
                        } else if (item.status == 0) {
                            item.statusStr = '禁用'
                        }
                    })
                } else { // 当字典接口慢于改接口请求完毕时使用定时器等待字典接口请求完成
                    let timer = setInterval(() => {
                        if ($scope.dictData.event_type) {
                            result.forEach((item) => {
                                if (item.eventTypes && item.eventTypes.length > 0) {
                                    item.eventTypeStr = dictDataHandle(item.eventTypes)
                                }
                                if (item.status == 1) {
                                    item.statusStr = '启用'
                                } else if (item.status == 0) {
                                    item.statusStr = '禁用'
                                }
                            })
                            $scope.listData = result
                            $scope.totalItems = res.data.value.total
                            clearInterval(timer)
                            timer = null
                        }
                    }, 100)
                }
                $scope.listData = result
                $scope.totalItems = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
            })
        }
        // 订阅事件字典处理
        function dictDataHandle(arr) {
            const result = []
            const dictData = $scope.dictData.event_type
            for (let j = 0, len = arr.length; j < len; j++) {
                for (let i = 0, l = dictData.length; i < l; i++) {
                    if (arr[j] == dictData[i].enumCode) {
                        result.push(dictData[i].enumName)
                    }
                }
            }
            return result.join(',')
        }
        // 分页
        $scope.pageChanged = function () { // 点击页码发起查询
            sessionStorage.setItem('externalSystemListParam', JSON.stringify({
                pageNum: $scope.queryParam.pageNum,
                pageSize: $scope.queryParam.pageSize,
                param: sessionStorage.externalSystemListParam ? JSON.parse(sessionStorage.externalSystemListParam).param : {
                    clientName: '',
                    status: '',
                },
            }, ))
            $scope.querySystemList()
        }
        $scope.querySystemList()
        // 表头排序
        $scope.orderMap = {
            sortKey: '',
            sortVal: ''
        }
        $scope.selectedHandle = function () {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem('externalSystemListParam', JSON.stringify($scope.queryParam))
            $scope.querySystemList()
        }
        $scope.search = function () {
            sessionStorage.setItem('externalSystemListParam', JSON.stringify($scope.queryParam))
            $scope.querySystemList()
        }

        $scope.tableDropdownConfig = [{
                label: '编辑',
                handler(item) {
                    $state.go('system.settingcenter.externalSystem.edit', {
                        clientId: item.clientId
                    })
                },
            },
            {
                label: '启用',
                handler(item) {
                    updateStatusHandle(item.clientId, item.status, item.interfaceType)
                },
                showWhile(item) {
                    return item.status == 0
                },
            },
            {
                label: '禁用',
                handler(item) {
                    updateStatusHandle(item.clientId, item.status, item.interfaceType)
                },
                showWhile(item) {
                    return item.status == 1
                },
            },
            {
                label: '刷新密钥',
                handler(item) {
                    sweetalert.confirm('操作提醒', '确认刷新该密钥吗？').then(() => {
                        httpRequest.get_updateClientSecret(item.clientId).then((res) => {
                            if (res.data.success) {
                                logger.logSuccess('密钥刷新成功')
                                $scope.querySystemList()
                            }
                        })
                    })
                },
                showWhile () {
                    return false
                }
            },
            {
                label: '下载windows客户端',
                handler(item) {
                    // GET /client/uimsClientDataSourcesConfig/getDataCollectClientZip 下载数据采集客户端
                    window.open(`${host.etcloudOpenapi}client/uimsClientDataSourcesConfig/getDataCollectClientZip?clientId=${item.clientId}&secretKey=${item.secretKey}&accessToken=${localStorage.getItem('id_token')}&type=1`)
                },
                showWhile(item) {
                    return item.interfaceType == 2
                }
            },
            {
                label: '下载linux客户端',
                handler(item) {
                    // GET /client/uimsClientDataSourcesConfig/getDataCollectClientZip 下载数据采集客户端
                    window.open(`${host.etcloudOpenapi}client/uimsClientDataSourcesConfig/getDataCollectClientZip?clientId=${item.clientId}&secretKey=${item.secretKey}&accessToken=${localStorage.getItem('id_token')}&type=2`)
                },
                showWhile(item) {
                    return item.interfaceType == 2
                }
            },
            {
                label: '数据源配置',
                handler(item) {
                    $uibModal.open({
                        template: dataSourceConfig,
                        controller: 'dataSourceConfigCtrl',
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-md mod-data-source-config',
                        resolve: {
                            itemData () {
                                return item
                            },
                            dictData () {
                                return $scope.dictData
                            }
                        },
                    }).result
                },
                showWhile(item) {
                    return item.interfaceType == 2
                }
            }
        ]
        // 启用/禁用处理函数
        function updateStatusHandle(id, status, interfaceType) {
            let tips = '确认启用此客户端系统吗？';
            let
                msg = '启用成功'
            if (status == 1) {
                tips = '确认禁用此客户端系统吗？'
                msg = '禁用成功'
            }
            sweetalert.confirm('操作提醒', tips).then(() => {
                status = status == 1 ? 0 : 1
                httpRequest.get_updateStatus({
                    id,
                    status,
                    interfaceType
                }).then((res) => {
                    if (res.data.success) {
                        logger.logSuccess(msg)
                        $scope.querySystemList()
                    }
                })
            })
        }
    }
}
externalSystemlistCtrl.$inject = ['$scope', 'httpRequest', '$state', 'sweetalert', 'logger', '$uibModal']
export default externalSystemlistCtrl


// WEBPACK FOOTER //
// ./src/app/system/settingcenter/externalSystem/list.js